(() => {
  'use strict';
  const messages = JSON.parse(document.getElementById('soluveli-i18n').textContent);
  const tr = (key, count) => (messages[key] || '').replace('{count}', String(count ?? ''));
  const trigger = document.querySelector('[data-cookie-preferences]');
  const status = document.querySelector('[data-cookie-status]');
  let queued = false;
  let dialogWasOpen = false;
  let restoreFocusTo = null;
  let preferencesRoot = null;
  function update() {
    queued = false;
    const banner = document.getElementById('shopify-pc__banner');
    if (banner && !banner.dataset.soluveliCookies) {
      const title = banner.querySelector('#shopify-pc__banner__body-title');
      const copy = banner.querySelector('.shopify-pc__banner__body p');
      const policy = banner.querySelector('#shopify-pc__banner__body-policy-link');
      if (title) title.textContent = tr('cookie_title');
      if (copy && policy) copy.replaceChildren(document.createTextNode(tr('cookie_body') + ' '), policy);
      if (policy) {
        policy.textContent = tr('policy_label');
        policy.href = messages.policy_url;
      }
      for (const [id, key] of Object.entries({
        'shopify-pc__banner__btn-accept': 'cookie_accept',
        'shopify-pc__banner__btn-decline': 'cookie_decline',
        'shopify-pc__banner__btn-manage-prefs': 'cookie_manage'
      })) {
        const button = banner.querySelector('#' + id);
        if (button) button.textContent = tr(key);
      }
      banner.dataset.soluveliCookies = 'true';
    }
    const preferences = document.getElementById('shopify-pc__prefs');
    if (preferences !== preferencesRoot) {
      preferencesObserver.disconnect();
      preferencesRoot = preferences;
      if (preferences) preferencesObserver.observe(preferences, { attributes: true, attributeFilter: ['style', 'hidden'] });
    }
    const dialog = document.getElementById('shopify-pc__prefs__dialog');
    if (dialog && !dialog.dataset.soluveliCookies) {
      const title = dialog.querySelector('#shopify-pc__prefs__header-title');
      const close = dialog.querySelector('#shopify-pc__prefs__header-close');
      if (title) title.textContent = tr('cookie_preferences');
      if (close) close.setAttribute('aria-label', tr('cookie_close'));
      for (const [selector, key] of Object.entries({
        '#shopify-pc__prefs__header-accept': 'cookie_accept_all',
        '#shopify-pc__prefs__header-decline': 'cookie_decline_all',
        '#shopify-pc__prefs__header-save': 'cookie_save',
        '.shopify-pc__prefs__intro-main h3': 'cookie_intro_title',
        '.shopify-pc__prefs__intro-main p': 'cookie_intro_body'
      })) {
        const element = dialog.querySelector(selector);
        if (element) element.textContent = tr(key);
      }
      for (const [id, key] of Object.entries({
        essential: 'cookie_essential', preferences: 'cookie_personalization',
        marketing: 'cookie_marketing', analytics: 'cookie_analytics'
      })) {
        const option = dialog.querySelector('#shopify-pc__prefs__' + id);
        const label = option?.querySelector('label');
        const labelText = label && Array.from(label.childNodes).find(node => node.nodeType === Node.TEXT_NODE);
        const description = option?.querySelector('p');
        // Keep Shopify's inputs, event listeners and consent state intact.
        if (labelText) labelText.nodeValue = tr(key);
        if (id === 'essential' && label) label.dataset.activeLabel = tr('cookie_active');
        if (description) description.textContent = tr(key + '_body');
      }
      dialog.dataset.soluveliCookies = 'true';
    }
    const dialogIsOpen = Boolean(dialog && preferences && !preferences.hidden && getComputedStyle(preferences).display !== 'none');
    document.documentElement.toggleAttribute('data-cookie-preferences-open', dialogIsOpen);
    if (!dialogIsOpen && dialogWasOpen && restoreFocusTo?.isConnected) {
      restoreFocusTo.focus({ preventScroll: true });
      restoreFocusTo = null;
    }
    dialogWasOpen = dialogIsOpen;
  }
  function queueUpdate() {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }
  const preferencesObserver = new MutationObserver(queueUpdate);
  new MutationObserver(queueUpdate).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('click', event => {
    const opener = event.target.closest?.('#shopify-pc__banner__btn-manage-prefs');
    if (opener) restoreFocusTo = opener;
  }, true);
  update();
  if (trigger && status) {
    trigger.hidden = false;
    trigger.addEventListener('click', async () => {
      trigger.disabled = true;
      status.hidden = true;
      restoreFocusTo = trigger;
      try {
        if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Privacy preferences unavailable');
        await window.privacyBanner.showPreferences();
        update();
      } catch {
        status.textContent = tr('cookie_error');
        status.hidden = false;
        restoreFocusTo = null;
      } finally {
        trigger.disabled = false;
      }
    });
  }
})();
